import type { ComponentPropsWithoutRef, ReactElement } from 'react'

import { components } from 'components/DefaultMdxComponents'
import type { Heading } from 'components/Heading'

import { extractElementText } from './extractElementText'
import { findElement } from './findElement'

export const getTitle = (element: ReactElement): string => {
	const title = findElement<ReactElement<ComponentPropsWithoutRef<typeof Heading>>>(
		element,
		({ type }) => type === components.h1,
	)

	if (!title) {
		throw new Error('Could not extract the title from the document')
	}

	return extractElementText(title.props.children)
}
